import { createContext, useState, ReactNode } from 'react'

import { DocumentsContextType } from '../types/context.types'

export const DocumentsContext = createContext<Partial<DocumentsContextType>>({})

const Provider = ({ children }: { children: ReactNode }) => {
  const [uploadingDocument, setUploadingDocument] = useState<boolean>(false)
  const [uploadingDocumentId, setUploadingDocumentId] = useState<string>(() => {
    if (typeof window !== 'undefined') {
      const storedValue = window.sessionStorage.getItem('uploadingDocumentId')
      return storedValue ? storedValue : ''
    }
    return ''
  })

  const value: DocumentsContextType = {
    uploadingDocument,
    uploadingDocumentId,
    setUploadingDocument,
    updateUploadingDocumentId: (documentId?: string) => {
      if (typeof window !== 'undefined' && documentId) {
        setUploadingDocumentId(documentId)
        window.sessionStorage.setItem('uploadingDocumentId', documentId)
        return true
      }

      if (typeof window !== 'undefined' && !documentId) {
        setUploadingDocumentId('')
        setUploadingDocument(false)
        window.sessionStorage.removeItem('uploadingDocumentId')
        return true
      }

      return false
    }
  }

  return <DocumentsContext.Provider value={value}>{children}</DocumentsContext.Provider>
}

const DocumentsContextProvider = {
  Provider,
  Consumer: DocumentsContext.Consumer
}

export default DocumentsContextProvider
